import { z, isoZ } from 'my-zod'
import { rentalEquipmentMetadata, merchandiseMetadata } from './add-on-product-metadata'
import { enumOptionsToObject } from '../../internal'

export const AddOnProductType = z.enum(['Merchandise', 'RentalEquipment']).setEnumLabels({
  Merchandise: 'Merchandise',
  RentalEquipment: 'Rental Equipment'
})

export type AddOnProductType = z.infer<typeof AddOnProductType>

export const addOnProductPriceUnitOptions = [
  'fixed',
  'fixedPerVehicle',
  'fixedPerVehiclePerDay',
  'percentageOfReservationSubtotal'
] as const

export const addOnProductPriceUnitTypes = enumOptionsToObject(addOnProductPriceUnitOptions)
export type AddOnProductPriceUnitType = (typeof addOnProductPriceUnitOptions)[number]
export const addOnPriceUnitTypeLabels = {
  fixed: 'Fixed',
  fixedPerVehicle: 'Fixed per vehicle',
  fixedPerVehiclePerDay: 'Fixed per vehicle per day',
  percentageOfReservationSubtotal: 'Percentage of reservation subtotal'
} satisfies Record<AddOnProductPriceUnitType, string>

export const addOnProductModel = z.object({
  id: z.string().uuid(),
  shortId: z.string(),
  versionId: z.number(),
  outfitterId: z.number().nullable(),
  price: z.number().min(0),
  priceUnit: z.enum(addOnProductPriceUnitOptions).setEnumLabels(addOnPriceUnitTypeLabels),
  title: z.string().nullable(),
  overview: z.string().nullable(),
  imageUrl: z.string().nullable(),
  type: AddOnProductType,
  metadata: merchandiseMetadata.or(z.null()),
  taxPolicyIds: z.number().array(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullish()
})

export type addOnProductModel = z.infer<typeof addOnProductModel>
